import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StringRequest } from "./StringRequest";
import { CreateSubRequest } from "./CreateSubRequest";
import { SubstituteDeleteRequest } from "./SubstituteDeleteRequest";

@Injectable()
export class DataService_SubstituteMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	SubstituteTableSelectList(SchoolID, PersonTypeID, IsSubbingToday, Active) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/SubstituteTableSelectList?SchoolID=" +
			SchoolID +
			"&PersonTypeID=" +
			PersonTypeID +
			"&IsSubbingToday=" +
			IsSubbingToday +
			"&Active=" +
			Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailProviderSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/EmailProviderSelectList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserNameAlreadyUsed(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/UserNameAlreadyUsed";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CreateSubstituteUser(parms: CreateSubRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/CreateSubstituteUser";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubstituteToggle(PersonID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SubstituteToggle?PersonID=" + PersonID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubAssignTableSelectList(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SubAssignTableSelectList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubstituteDeleteList(parms: SubstituteDeleteRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SubstituteDeleteList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadInstructorList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/LoadInstructorList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubstitutionInsert(PersonID, SubID, StartDate, EndDate, C_PersonID) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/SubstitutionInsert?Substitute_PersonID=" +
			PersonID +
			"&Alias_PersonID=" +
			SubID +
			"&StartDate=" +
			StartDate +
			"&EndDate=" +
			EndDate +
			"&c_PersonID=" +
			C_PersonID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubstitutionUpdate(SubstitutionID, Substitute_PersonID, StartDate, EndDate, c_PersonID) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/SubstitutionUpdate?SubstitutionID=" +
			SubstitutionID +
			"&Substitute_PersonID=" +
			Substitute_PersonID +
			"&StartDate=" +
			StartDate +
			"&EndDate=" +
			EndDate +
			"&c_PersonID=" +
			c_PersonID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubHistoryTableSelectList(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SubHistoryTableSelectList?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SubHistoryDetailsTableInfoSelectList(SubstitutionID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/SubHistoryDetailsTableInfoSelectList?SubstitutionID=" + SubstitutionID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
